var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"alt-heading"},[_vm._v(_vm._s(_vm.headingTitle))]),_c('div',{attrs:{"id":"works-container"}},[_c('DemoGroup')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }